import { createAsyncThunk } from "@reduxjs/toolkit";

import { getErrorMessage } from "@fitness-app/utils";

import { type ActionParams, type AsyncThunkCreator } from "../../../index";
import { PRODUCT_CLIENT_REDUCER } from "../types";

type Payload = {
  invoiceRequest: boolean;
  email: string;
  productId: string;
};

export const updateInvoiceRequest = createAsyncThunk<void, ActionParams<Payload>, AsyncThunkCreator<string>>(
  `${PRODUCT_CLIENT_REDUCER}/updateInvoiceRequest`,
  async ({ payload, onSuccess, onFailure }, { rejectWithValue, extra: { db } }) => {
    try {
      // `select()` is what makes an RLS refusal visible: without it PostgREST
      // answers 204 for a row the policy filtered out, so a blocked write is
      // indistinguishable from a successful one and the switch just snaps back
      // with no error (TRE-2143).
      const { data, error } = await db
        .from("product_client")
        .update({
          invoiceRequested: payload.invoiceRequest,
        })
        .eq("email", payload.email)
        .eq("productId", payload.productId)
        .select("id");

      if (error) {
        onFailure?.();

        return rejectWithValue(error.message);
      }

      if (!data?.length) {
        onFailure?.();

        return rejectWithValue("No product client row was updated");
      }

      onSuccess?.();
    } catch (e) {
      onFailure?.();

      return rejectWithValue(getErrorMessage(e));
    }
  },
);
